/**
 * Success Stories Slider
 */
import { Swiper } from 'swiper';
import { Navigation, EffectFade } from 'swiper/modules';

export function initSuccessStoriesSlider() {
    const successStoriesSlider = document.querySelector('.acc_success_stories__slider');
    if (!successStoriesSlider) return;

    const prevButton = document.querySelector('.acc_success_stories__nav-prev');
    const nextButton = document.querySelector('.acc_success_stories__nav-next');

    const swiper = new Swiper(successStoriesSlider, {
        modules: [Navigation, EffectFade],
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        speed: 400, // 400ms transition duration
        loop: true,
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        on: {
            init: function() {
                console.log('Success Stories slider initialized');
                updateContent();
            },
            slideChange: function() {
                updateContent();
            },
            slideChangeTransitionEnd: function() {
                updateContent();
            }
        }
    });

    // Function to update logo and tags based on active slide
    function updateContent() {
        // Get the active slide directly from Swiper's active slide
        const activeSlide = document.querySelector('.acc_success_stories__slider .swiper-slide-active');
        
        if (!activeSlide) return;

        // Update logo
        const logo = activeSlide.getAttribute('data-logo');
        const logoImg = document.querySelector('.acc_success_stories__client-logo img');
        if (logoImg && logo) {
            logoImg.src = logo;
            logoImg.alt = activeSlide.querySelector('img')?.alt || 'Client logo';
        }

        // Update tags
        const tagsData = activeSlide.getAttribute('data-tags');
        const tagsContainer = document.querySelector('.acc_success_stories__tags');
        
        if (tagsContainer && tagsData) {
            try {
                const tags = JSON.parse(tagsData);
                tagsContainer.innerHTML = '';
                
                tags.forEach(tag => {
                    const tagElement = document.createElement('span');
                    tagElement.className = 'tag tag--orange';
                    tagElement.textContent = tag;
                    tagsContainer.appendChild(tagElement);
                });
            } catch (e) {
                console.error('Error parsing tags data:', e);
            }
        }
    }

    // Add template URL to body for JS access
    if (!document.body.getAttribute('data-template-url')) {
        document.body.setAttribute('data-template-url', window.location.origin + '/wp-content/themes/nouslagence');
    }
}